<template>
  <div>
    <div class="banner" :style="{backgroundImage: 'url('+banner+')'}">
      <div class="userCon">
        <h1>{{ itemData.itemName }}</h1>
        <p>{{ itemData.itemDesc }}</p>
      </div>
    </div>
    <div class="content userCon">
      <div class="left">

        <div class="minHeight">
          <span class="title">{{ title }}</span>
          <div v-if="page.total==0" class="empty">
            <img src="../../assets/img/empty_tips.png" alt="">
            <div>暂无数据</div>
          </div>
          <template v-else>
            <div v-for="(item,ind) in page.rows.slice(0,1)" :key="ind" class="popularScience">
              <div class="objImg img" v-if="item.thumbnailPath"
                   :style="'backgroundImage: url('+item.thumbnailPath+')'"></div>
              <div class="scienceList">
                <h2 class="title">{{ item.title }}</h2>
                <p class="desc">{{ item.summary }}</p>
                <div class="content" style="display: block" v-html="item.pageContent"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import base from "@/api/common";

export default {
  name: "articleDetail",
  data() {
    return {
      itemData: [],
      itemId: this.$route.query.itemId,
      subitemId: this.$route.query.id,
      page: {
        type: 0,
        current: 1,
        size: 2,
        total: 16,
        rows: []
      },
      banner: null,
      title: '',//子标题
    }
  },
  mounted() {
    // 文字信息
    this.$ajax.get(base.api.dict.item.getById.replace("{id}", this.itemId)).then((res) => {
      if (res.data.status === 'success') {
        this.itemData = res.data.data;
        this.getBanner()
      }
    })
    this.getArticles()
    this.getSystemArticle()
  },
  methods: {
    getSystemArticle() {
      let that = this;
      this.$ajax.get(base.api.article.system.page
          .replace("{subitemId}", this.subitemId)
          .replace("{currentPage}", this.page.current)
          .replace("{size}", this.page.size)
      ).then((res) => {
        if (res.data.status === 'success') {
          that.page.rows = res.data.rows;
          that.page.size = res.data.size;
          that.page.total = res.data.total;
          that.page.current = res.data.current;
        }
      })
    },
    getBanner() {
      // banner
      this.$ajax.get(base.api.dict.item.getByItemCode.replace("{itemCode}", this.itemData.itemCode + "_pc_img")).then((res) => {
        if (res.data.status === 'success') {
          this.banner = res.data.data.itemIcon;
        }
      })
    },
    getArticles() {
      this.$ajax.get(base.api.dict.sub.getById.replace("{id}", this.subitemId)).then((res) => {
        if (res.data.status === 'success') {
          this.title = res.data.data.subName
          // this.banner = res.data.data.itemIcon;
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index_b';
</style>
